import { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  Button,
  Grid,
  FormControl,
  InputAdornment,
  InputLabel,
  Modal,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { BCPStopwatch } from "../icons/bcp/BCPIcons";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  formControl: { backgroundColor: theme?.palette?.background.paper },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

export default function TimerPicker(props) {
  const {
    label,
    name,
    value,
    setFieldValue,
    touched,
    error,
    zIndex,
    disabled,
  } = props;
  const { t } = useTranslation("translation", {
    keyPrefix: "components.TimerPicker",
  });
  const [open, setOpen] = useState(false);
  const [hours, setHours] = useState([]);
  const [mins, setMins] = useState([]);
  const [localHours, setLocalHours] = useState(value?.hrs || 0);
  const [localMins, setLocalMins] = useState(value?.mins || 0);
  const classes = useStyles();

  useEffect(() => {
    var hoursArray = [];
    for (var h = 0; h <= 23; h++) {
      hoursArray.push(h);
    }
    setHours(hoursArray);
    var minsArray = [];
    for (var m = 0; m <= 59; m++) {
      minsArray.push(m);
    }
    setMins(minsArray);
  }, []);

  useEffect(() => {
    if (open) {
      setLocalHours(value?.hrs || 0);
      setLocalMins(value?.mins || 0);
    }
  }, [open, value]);

  const handleSave = () => {
    setFieldValue(`${name}.hrs`, localHours);
    setFieldValue(`${name}.mins`, localMins);
    setOpen(false);
  };

  const handleCancel = () => {
    setLocalHours(value?.hrs || 0);
    setLocalMins(value?.mins || 0);
    setOpen(false);
  };

  return (
    <>
      <TextField
        label={label || "Timer Settings"}
        value={`${value?.hrs || 0}hrs ${value?.mins ? value.mins.toString().padStart(2, "0") : "00"
          }mins`}
        variant="outlined"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <BCPStopwatch />
            </InputAdornment>
          ),
        }}
        onClick={(e) => {
          if (!disabled) {
            setOpen(true);
          }
        }}
        disabled={disabled}
      />
      <Modal
        disableAutoFocus
        open={open}
        onClose={handleCancel}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        sx={{
          zIndex: (zIndex || 99990) + 1,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 300,
            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            {t("roundTimerLength")}
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                sx={{ mt: 2, mb: 1 }}
              >
                <InputLabel id={`${name}-hrs`}>Hours</InputLabel>
                <Select
                  error={Boolean(touched && error)}
                  fullWidth
                  helperText={touched && error}
                  labelId={`${name}-hrs`}
                  name={`${name}.hrs`}
                  value={localHours}
                  onChange={(e) => {
                    setLocalHours(e.target.value);
                  }}
                  label="Hours"
                  variant="outlined"
                  MenuProps={{
                    sx: { zIndex: `${(zIndex || 99990) + 2} !important` },
                  }}
                >
                  {hours.map((h) => (
                    <MenuItem key={h} value={h}>
                      {h}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
                sx={{ mt: 2, mb: 1 }}
              >
                <InputLabel id={`${name}-mins`}>Minutes</InputLabel>
                <Select
                  error={Boolean(touched && error)}
                  fullWidth
                  helperText={touched && error}
                  labelId={`${name}-mins`}
                  name={`${name}.mins`}
                  value={localMins}
                  onChange={(e) => {
                    setLocalMins(e.target.value);
                  }}
                  label="Minutes"
                  variant="outlined"
                  MenuProps={{
                    sx: { zIndex: `${(zIndex || 99990) + 2} !important` },
                  }}
                >
                  {mins.map((m) => (
                    <MenuItem key={m} value={m}>
                      {m}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="outlined"
                color="error"
                onClick={handleCancel}
              >
                {t("cancel")}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSave}
              >
                {t("save")}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}
